export const RTK_TAGS = {
  RatingMatrixFramework: 'RatingMatrixFramework',
  RatingMatrixFrameworkTemplate: 'RatingMatrixFrameworkTemplate',
  RatingMatrixFrameworkConsideration: 'RatingMatrixFrameworkConsideration',
  RatingMatrixFrameworkGradeScore: 'RatingMatrixFrameworkGradeScore',
  RatingMatrixFrameworkParameter: 'RatingMatrixFrameworkParameter',
  RatingMatrixFrameworkSubParameter: 'RatingMatrixFrameworkSubParameter',
  RatingMatrixFrameworkOption: 'RatingMatrixFrameworkOption',
  RatingMatrixFrameworkRange: 'RatingMatrixFrameworkRange',
  Methodology: 'Methodology',
  Sector: 'Sector',
  CommitteeBallot: 'CommitteeBallot',
} as const;

export const RTK_TAG_IDS = {
  LIST: 'LIST',
  ACTIVE: 'ACTIVE',
} as const;

export type RtkTagType = (typeof RTK_TAGS)[keyof typeof RTK_TAGS];

export const frameworkListTag = {
  type: RTK_TAGS.RatingMatrixFramework,
  id: RTK_TAG_IDS.LIST,
} as const;

export const methodologyActiveTag = {
  type: RTK_TAGS.Methodology,
  id: RTK_TAG_IDS.ACTIVE,
} as const;

export const sectorActiveTag = {
  type: RTK_TAGS.Sector,
  id: RTK_TAG_IDS.ACTIVE,
} as const;

export const considerationListTag = (templateId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkConsideration,
    id: templateId,
  }) as const;

export const gradeScoreListTag = (templateId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkGradeScore,
    id: templateId,
  }) as const;

export const parameterListTag = (templateId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkParameter,
    id: templateId,
  }) as const;

export const subParameterListTag = (templateId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkSubParameter,
    id: templateId,
  }) as const;

export const optionListTag = (subParameterId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkOption,
    id: subParameterId,
  }) as const;

export const rangeListTag = (subParameterId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkRange,
    id: subParameterId,
  }) as const;

export const templateDetailTag = (templateId: number) =>
  ({
    type: RTK_TAGS.RatingMatrixFrameworkTemplate,
    id: templateId,
  }) as const;

export const committeeBallotTag = (committeeFrameworkId: number) =>
  ({
    type: RTK_TAGS.CommitteeBallot,
    id: committeeFrameworkId,
  }) as const;
